export default __webpack_public_path__ + "static/banner-mobile-ppc-1-5a62a1c5ffa737f041b05e0c01ee2526.png";